$(window).on("load", function () {
$(".js-acc-single-trigger2").attr("aria-expanded","true");
$(".js-acc-single-trigger2").removeClass('collapsed');
$('#collapse2').addClass('in');
$("#collapse2").attr("aria-expanded","true");  
});

$(function() {
  $('.accordion-heading .accordion-toggle').on('click', toggleAccordion);
  function toggleAccordion(event) {
    var target = $(event.target)
    var content = target.next('.accordion-body');
    content.parent('.accordion').find('.accordion-body').not(content).removeClass('in');
    target.toggleClass('in');
    content.toggleClass('in');
  }
});
  
$(document).ready(function(){
    $("[data-parent='#accordion']").on("click", function(e){
        var trigger = $(this);
        var navHeight = $(document).height();
       $('html, body').css({height: 'auto'}).animate({
        scrollTop: $(".tab-container").offset().top
    }, 100);
     
});  
});  